module.exports = __webpack_public_path__ + "static/img/xicha.80db14a6.jpg";